import styled from '@emotion/styled';
import { Y400, N700 } from '../../../components/Colors';

export const Content = styled.div`
    .margin-auto {
        margin: auto;
    }
    .btn-primary {
        margin-top : 20px;
    }

`;

export const ButtonKembali = styled.button`
    background-color: ${Y400};
    border-color: ${Y400};
    color: ${N700};
    box-shadow: 1px 3px 5px #888888;
    padding: 8px;
    border-radius: 8px;
`;
